import { storageToken } from '@src/constants/keys';

export const isAuthenticated = () => {
  const token = localStorage.getItem(storageToken);
  return token ? true : false;
};
